import React//, { useState }
      from 'react';
import {
  Box
} from '@mui/material';
import TopAppBar from '../components/topAppBar';
import ListadoProtocolos from '../components/listadoProtocolo';
import { Route, Routes } from 'react-router-dom';
import ListadoPrestaciones from '../components/listadoPrestaciones';
import {InfoCuenta} from '../components/infoCuenta';
import { Persona } from '../../logic/domain/entities/persona';



interface DashboardProps {
  onLogout: () => void;
  user:Persona
}

const Dashboard: React.FC<DashboardProps> = ({ onLogout,user }) => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        backgroundImage: process.env.REACT_APP_BACKGROUND_IMAGE || "none",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <TopAppBar topBarLogOut={onLogout} user={user}/>
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Box>
          <Routes>
            <Route path="/listadoprotocolos" element={<ListadoProtocolos onLogoutListadoProtocolos={onLogout}/>} />
            <Route
              path="/listadoprestaciones"
              element={<ListadoPrestaciones onLogoutListadoPrestaciones={onLogout}/>}
            />
            <Route path="/infocuenta" element={<InfoCuenta user={user}/>} />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;



interface DashboardProps {
  onLogout: () => void;
}